document.addEventListener('click', function (event) {
    let el = event.target as HTMLFormElement

    if (el.classList.contains('credit-check-btn')) {
        let data = new FormData(el.form);

        fetch('/?handler=GetCredit', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: data
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                var ele = document.getElementById('my-credit-score');
                if (ele) {
                    ele.innerHTML = data.score;

                    let r = null;
                    if (data.score >= 750) {
                        r = document.getElementById('credit-score-excellent') as HTMLInputElement;
                    }
                    else if (data.score >= 700 && data.score <= 749) {
                        r = document.getElementById('credit-score-good') as HTMLInputElement;
                    }
                    else if (data.score >= 640 && data.score <= 699) {
                        r = document.getElementById('credit-score-fair') as HTMLInputElement;
                    }
                    else if (data.score <= 639) {
                        r = document.getElementById('credit-score-poor') as HTMLInputElement;
                    }

                    if (r) {
                        r.click();
                        r.checked = true;
                    }
                }
            })
            .catch(error => {
                alert("Error: " + error)
            });

    }
})